// Only allow same-site relative paths as post-auth redirect targets.
export const safeNext = (raw) => (raw && raw.startsWith('/') && !raw.startsWith('//') ? raw : '');
